import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonLoading, FormGroupComponent, InputText, ModalContent, ValidationFeedback } from '@cfp/ui';
import { AlertService } from '@cfp/ui/feedback';
import { TranslateModule } from '@ngx-translate/core';
import { TagsService } from 'csr-asset-app';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'cfp-tags-add-modal',
  templateUrl: './tags-add-modal.html',
  imports: [
    ModalContent,
    TranslateModule,
    ButtonLoading,
    ValidationFeedback,
    InputText,
    FormGroupComponent,
    ReactiveFormsModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagsAddModal {
  public portfolioId: number;
  public closeClicked: Subject<boolean> = new Subject();

  private readonly tagsService = inject(TagsService);
  private readonly bsModalRef = inject(BsModalRef);
  private readonly alertService = inject(AlertService);
  private readonly formBuilder = inject(FormBuilder);

  protected saving = signal<boolean>(false);

  protected form = this.formBuilder.group({
    tag: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(50)])
  });

  protected close(): void {
    this.closeClicked.next(true);
    this.bsModalRef.hide();
  }

  protected submit(): void {
    if (this.form.invalid) {
      return;
    }

    const tag = this.form.value.tag;
    if (!tag) {
      return;
    }

    this.saving.set(true);
    this.form.disable();
    this.tagsService.v2PortfoliosPortfolioIdTagsPost({ tag: tag }, this.portfolioId).subscribe({
      next: () => {
        this.close();
      },
      error: () => {
        this.alertService.showAlert('error', 'error.general');
        this.saving.set(false);
        this.form.enable();
      }
    });
  }
}
